module.exports = __webpack_public_path__ + "static/media/alert_3.aec4a4a2.svg";